import { useTranslation } from 'react-i18next'
import { StyledInput, StyledInputContainer, StyledSearchIcon } from './styles'

type SearchInputProps = {
  setSearch: (search: string) => void
}

const SearchInput = ({ setSearch }: SearchInputProps) => {
  const { t } = useTranslation()

  return (
    <StyledInputContainer>
      <StyledSearchIcon />
      <StyledInput
        placeholder={t('claimsPage.searchPlaceholder')}
        onChange={(e) => setSearch(e.target.value)}
      />
    </StyledInputContainer>
  )
}

export default SearchInput
